/* =============================================================
   VFW Product Page — Vanilla JS
   Handles: gallery, variant selection, AJAX cart, tabs, FAQ
   ============================================================= */
(function () {
  'use strict';

  /* ── Gallery ──────────────────────────────────────────────── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.vfw-gallery_thumb');
    var mainImg = document.getElementById('vfw-main-img');
    var mainStage = document.querySelector('.vfw-gallery_main');

    function clearVideoPlayers() {
      if (!mainStage) return;
      var v = document.getElementById('vfw-stage-video');
      var e = document.getElementById('vfw-stage-embed');
      if (v) { v.pause(); v.remove(); }
      if (e) e.remove();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaType = thumb.dataset.mediaType || 'image';
        var alt = thumb.dataset.alt || '';

        clearVideoPlayers();

        if (mediaType === 'video') {
          var videoSrc = thumb.dataset.videoSrc;
          if (mainImg) mainImg.style.display = 'none';
          if (videoSrc && mainStage) {
            var video = document.createElement('video');
            video.id = 'vfw-stage-video';
            video.className = 'vfw-gallery_main-img';
            video.controls = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            var source = document.createElement('source');
            source.src = videoSrc;
            source.type = 'video/mp4';
            video.appendChild(source);
            mainStage.appendChild(video);
            video.play().catch(function () {});
          }
        } else if (mediaType === 'external_video') {
          var embedSrc = thumb.dataset.embedSrc;
          if (mainImg) mainImg.style.display = 'none';
          if (embedSrc && mainStage) {
            var iframe = document.createElement('iframe');
            iframe.id = 'vfw-stage-embed';
            iframe.className = 'vfw-gallery_main-img';
            iframe.src = embedSrc;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            mainStage.appendChild(iframe);
          }
        } else {
          if (mainImg) {
            mainImg.style.display = '';
            var src = thumb.dataset.src;
            if (src) {
              mainImg.src = src;
              mainImg.srcset = '';
              mainImg.alt = alt;
            }
          }
        }

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Gallery Scroll Arrows ────────────────────────────────── */
  function initGalleryScroll() {
    var thumbsEl = document.getElementById('vfw-gallery-thumbs');
    if (!thumbsEl) return;

    /* Only add arrows when content actually overflows */
    if (thumbsEl.scrollHeight <= thumbsEl.clientHeight + 2) return;

    var col = thumbsEl.closest('.vfw-gallery_thumbs-col');
    if (!col) return;

    var STEP = 88 * 2; /* scroll two thumbs at a time */

    var btnUp = document.createElement('button');
    btnUp.type = 'button';
    btnUp.className = 'vfw-gallery_scroll-btn';
    btnUp.setAttribute('aria-label', 'Scroll thumbnails up');
    btnUp.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"/></svg>';

    var btnDown = document.createElement('button');
    btnDown.type = 'button';
    btnDown.className = 'vfw-gallery_scroll-btn';
    btnDown.setAttribute('aria-label', 'Scroll thumbnails down');
    btnDown.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    col.insertBefore(btnUp, thumbsEl);
    col.appendChild(btnDown);

    btnUp.addEventListener('click', function () { thumbsEl.scrollBy({ top: -STEP, behavior: 'smooth' }); });
    btnDown.addEventListener('click', function () { thumbsEl.scrollBy({ top: STEP, behavior: 'smooth' }); });

    function syncArrows() {
      btnUp.classList.toggle('is-disabled', thumbsEl.scrollTop <= 0);
      btnDown.classList.toggle('is-disabled', thumbsEl.scrollTop + thumbsEl.clientHeight >= thumbsEl.scrollHeight - 2);
    }
    thumbsEl.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();
  }

  /* ── Finish / Color Swatches ──────────────────────────────── */
  function initSwatches() {
    document.querySelectorAll('.vfw-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var oi = swatch.dataset.optionIndex;
        var val = swatch.dataset.swatchValue;

        /* Activate clicked swatch */
        document.querySelectorAll('.vfw-swatch[data-option-index="' + oi + '"]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        /* Sync hidden select and fire change so variant JS picks it up */
        var sel = document.querySelector('.vfw-panel_select--hidden[data-option-index="' + oi + '"]');
        if (sel) {
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Update "FINISH: [name]" label */
        var label = document.querySelector('[data-swatch-label="' + oi + '"]');
        if (label) label.textContent = val;
      });
    });
  }

  /* ── Quantity Stepper ─────────────────────────────────────── */
  function initStepper() {
    document.querySelectorAll('.vfw-panel_stepper-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.vfw-panel_stepper').querySelector('.vfw-panel_qty');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.stepper === 'increment') {
          input.value = val + 1;
        } else if (btn.dataset.stepper === 'decrement' && val > 1) {
          input.value = val - 1;
        }
        updateTotalPrice();
      });
    });
  }

  /* ── Shared Utilities ────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  function updateTotalPrice() {
    var priceEl = document.getElementById('vfw-price');
    var qtyEl = document.getElementById('vfw-qty');
    if (!priceEl || !priceEl.dataset.unitPrice) return;
    var unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
    var qty = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
    var total = formatMoney(unitPrice * qty);
    priceEl.textContent = total;
    /* One source of truth: every price display follows the main form. */
    document.querySelectorAll('[data-unit-price-display]').forEach(function (el) { el.textContent = formatMoney(unitPrice); });
    document.querySelectorAll('[data-four-total]').forEach(function (el) { el.textContent = formatMoney(unitPrice * 4); });
  }

  /* ── Variant Selection ────────────────────────────────────── */
  function initVariants() {
    const form = document.querySelector('.vfw-product-form');
    if (!form) return;

    const jsonEl = form.querySelector('[data-product-variants]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    /* Keyed by variant id, written by Liquid — see the note beside the tag.
       Null when the tag is missing, and the caller falls back to
       `variant.available` rather than claiming everything is made to order. */
    var stockEl = form.querySelector('[data-variant-stock]');
    var stockMap = null;
    if (stockEl) { try { stockMap = JSON.parse(stockEl.textContent); } catch (e) { stockMap = null; } }

    var selects = Array.from(form.querySelectorAll('.vfw-panel_select[data-option-index]'));
    var priceEl = document.querySelector('.vfw-panel_price');
    var atcBtn = form.querySelector('.vfw-panel_atc');
    var statusEl = document.querySelector('.vfw-panel_status');
    var variantIdInput = form.querySelector('[name="id"]');

    function getSelected() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant(opts) {
      /* Single-variant products render NO option selects, so `opts` is empty
         and the every() comparison fails against ["Default Title"] — the JS
         then stamped a purchasable product "Unavailable" over the correct
         Liquid-rendered button (caught on the Heritage Mag PDP, 2026-07-30).
         No selects → the only variant IS the selection. */
      if (!selects.length) return variants[0] || null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) {
        /* No variant matches the chosen options — that is a selection problem,
           not a stock problem, so the button stays live and says so. */
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) {
        priceEl.dataset.unitPrice = variant.price;
        updateTotalPrice();
      }

      /* Every wheel is orderable whether or not a set is on the shelf, so the
         buy button never changes shape between variants — only the status
         line above it does. Stock on hand, not purchasability, drives it. */
      var inStock = stockMap ? stockMap[variant.id] === true : variant.available;

      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.innerHTML = 'Add to Cart <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
      }

      document.querySelectorAll('[data-pnav-atc]').forEach(function (b) {
        b.disabled = false;
        var label = b.querySelector('[data-pnav-atc-label]') || b;
        label.textContent = 'Add to Cart';
      });

      if (statusEl) {
        var text = statusEl.querySelector('.vfw-panel_status-text');
        statusEl.className = 'vfw-panel_status ' + (inStock ? 'vfw-panel_status--in-stock' : 'vfw-panel_status--mto');
        if (text) text.textContent = inStock ? (statusEl.dataset.availableText || 'In Stock') : (statusEl.dataset.soldOutText || 'Made to Order');
      }

      /* Switch gallery to variant image */
      if (variant.featured_image) {
        var mainImg = document.getElementById('vfw-main-img');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.alt = variant.featured_image.alt || '';
        }
        /* Activate matching thumb */
        var thumbs = document.querySelectorAll('.vfw-gallery_thumb');
        thumbs.forEach(function (t) {
          if (t.dataset.src === variant.featured_image.src) {
            thumbs.forEach(function (x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
          }
        });
      }

      /* Update URL without reload */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateUI(findVariant(getSelected()));
      });
    });

    /* Init on page load */
    var params = new URLSearchParams(window.location.search);
    var urlVariantId = params.get('variant');
    if (urlVariantId) {
      var v = variants.find(function (x) { return String(x.id) === urlVariantId; });
      if (v) {
        /* Pre-select option dropdowns */
        selects.forEach(function (sel, i) {
          var opt = Array.from(sel.options).find(function (o) { return o.value === v.options[i]; });
          if (opt) sel.value = opt.value;
        });
        updateUI(v);
        return;
      }
    }
    updateUI(findVariant(getSelected()));
  }

  /* ── Add-to-Cart ──────────────────────────────────────────────
     Native form POST, deliberately. The old AJAX path intercepted
     the submit and flashed "Added ✓" for 2s with no drawer, no
     badge update (its selectors/events matched nothing in Horizon
     4.x) — a silent add that read as a broken button. The form
     already carries return_to=/cart, so the browser lands on the
     cart page with the item visible: deterministic feedback with
     zero coupling to the theme's private event system. We only
     dress the button while the navigation happens. */
  function initCart() {
    var form = document.querySelector('.vfw-product-form');
    if (!form) return;

    /* An unchosen vehicle must not post an empty line-item property. */
    form.addEventListener('submit', function () {
      var veh = form.querySelector('[data-vehicle-select]');
      if (veh && !veh.value) veh.disabled = true;
    });

    form.addEventListener('submit', function () {
      var btn = form.querySelector('.vfw-panel_atc');
      if (!btn) return;
      btn.textContent = 'Adding…';
      btn.classList.add('vfw-panel_atc--loading');
      /* not disabled — a disabled control would block the submit itself
         in some browsers; double-submit is prevented by navigation */
    });
  }

  /* ── Tabs ─────────────────────────────────────────────────── */


  /* ── FAQ Accordion ────────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.vfw-faq-item_q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.vfw-faq-item');
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.vfw-faq-item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }


  /* ── Specs / Fitment Dynamic Sync ───────────────────────── */
  function initSpecsSync() {
    document.querySelectorAll('.vfw-panel_select[data-option-name]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var oname = (sel.dataset.optionName || '').toLowerCase();
        var val = sel.value;
        if (oname === 'size' || oname === 'wheel size') {
          var el = document.getElementById('vfw-spec-size');
          if (el) el.textContent = val;
        } else if (oname === 'finish' || oname === 'color' || oname === 'colour') {
          var el = document.getElementById('vfw-spec-finish');
          if (el) el.textContent = val;
        }
      });
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initGalleryScroll();
    initSwatches();
    initStepper();
    initVariants();
    initSpecsSync();
    initCart();
    initFaq();

    /* Zero outer .vfw-section wrapper padding on FAQ section — runs only on product pages since vfw-product.js is product-only */
    var faqInner = document.querySelector('.vfw-faq');
    if (faqInner && faqInner.parentElement && faqInner.parentElement.classList.contains('vfw-section')) {
      faqInner.parentElement.style.setProperty('padding-top', '0', 'important');
      faqInner.parentElement.style.setProperty('padding-bottom', '0', 'important');
    }
  });

}());
